export function findFirstResolvingAccount<T extends { id: string }>(
    accountIds: string[],
    accounts: T[] | undefined,
): T | undefined {
    if (!accounts) {
        return undefined;
    }

    for (const accountId of accountIds) {
        const account = accounts.find(
            (candidate) => candidate.id === accountId,
        );
        if (account) {
            return account;
        }
    }

    return undefined;
}
